<template>
    <div class="login-modal">
        <div
            class="form"
        >
            <GenericForm
                :fields="fields"
                :asyncErrors="asyncErrors"
                :asyncFieldError="asyncFieldError"
                @submit="onSubmitClick"
            >
                <template slot-scope="slotProps">
                    +43
                    <CustomInput
                        name="phone"
                        v-model="fields.phone.value"
                        label="phone"
                        :errorMessage="slotProps.errors.phone"
                        @valueChanged="slotProps.onValueChanged"
                        @blur="slotProps.onBlur"
                    />
                    PL61
                    <CustomInput
                        name="bankAccount"
                        v-model="fields.bankAccount.value"
                        label="Bank Account"
                        :errorMessage="slotProps.errors.bankAccount"
                        placeholder="Polish bank account number"
                        @valueChanged="slotProps.onValueChanged"
                        @blur="slotProps.onBlur"
                    />
                    <CustomInput
                        v-if="isPolish"
                        name="documentId"
                        v-model="fields.documentId.value"
                        label="ID or passport number"
                        :errorMessage="slotProps.errors.documentId"
                        @valueChanged="slotProps.onValueChanged"
                        @blur="slotProps.onBlur"
                    />
                    <Address
                        v-if="isPolish"
                        :country.sync="fields.country.value"
                        :county.sync="fields.county.value"
                        :city.sync="fields.city.value"
                        :postalCode.sync="fields.postalCode.value"
                        :address.sync="fields.address.value"
                        :isLivingInPoland="isLivingInPoland"
                        :errors="slotProps.errors"
                        @valueChanged="slotProps.onValueChanged"
                        @blur="slotProps.onBlur"
                    />
                    <CustomButton
                        :isLoading="isLoading"
                        type="submit"
                        class="btn btn__primary btn--block"
                    >
                        {{ $t('login') | capitalize }}
                    </CustomButton>
                </template>
            </GenericForm>
        </div>
    </div>
</template>

<script>
    import {
        forEach as _forEach,
    } from '@lodash';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import { errorGuard } from '@app/utils';
    import { mapActions, mapGetters } from 'vuex';
    import ValidationError from '@core/errors/network/ValidationError';
    import {
        isRequired,
    } from '@modules/shared/validators/forms';
    import Address from '@countryModules/authentication/components/register/Address';
    import PolandRegisterMixin from '../modules/authentication/mixins/PolandRegisterMixin';

    export default {
        mixins: [PolandRegisterMixin],
        data() {
            return {
                validationErrorsPattern: /#.+?REGFIELD /gi,
                isLoading: false,
                error: '',
                fields: {
                    bankAccount: {
                        value: '',
                        validate: [
                            isRequired,
                        ]
                    },
                    phone: {
                        value: '',
                        validate: [
                            isRequired,
                        ]
                    },
                    country: {
                        value: null,
                        validate: [
                            isRequired,
                        ],
                    },
                },
                asyncErrors: {},
                asyncFieldError: {},
            };
        },
        created() {
            if (this.isPolish) {
                this.addFields({
                    documentId: {
                        value: '',
                        validate: [
                            isRequired,
                        ],
                        isPolish: true,
                    },
                    ...this.addressFields
                });
            }
            // TODO
            // this.isLivingInPoland = this.user.readCountry === config.poland;
            this.isLivingInPoland = false;
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user'
            ]),
            isPolish() {
                // TODO procitaj user nationality
                return true;
            }
        },
        methods: {
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            ...mapActions('ui/modal', [
                'setModal',
                'closeAllModals',
            ]),
            ...mapActions('errors', [
                'showError',
            ]),
            ...mapActions('data/authentication', [
                'register',
            ]),
            async onSubmitClick() {
                this.isLoading = true;
                this.asyncErrors = {};
                await errorGuard({
                    action: async () => {
                        const data = this.prepareData();
                        // TODO pravi API endpoint
                        await this.register(data);
                        this.closeAllModals();
                        this.setModal(Modals.idCardVerificationIntro.code);
                    },
                    onError: (e) => {
                        if (e instanceof ValidationError) {
                            _forEach(e.fieldErrors, (value, key) => {
                                e.fieldErrors[key] = value
                                    .map((item) => item.replace(this.validationErrorsPattern, ''));
                            });
                            this.asyncErrors = e.fieldErrors;
                        } else {
                            this.showError(e);
                        }
                    },
                });
                this.isLoading = false;
            },
            prepareData() {
                const data = {};
                Object.keys(this.fields).forEach((key) => {
                    if (!this.isPolish && this.fields[key].isPolish) {
                        return;
                    }
                    data[key] = this.fields[key].value;
                });
                data.phone = `43${data.phone}`;
                data.bankAccount = `PL61${data.bankAccount}`;
                return data;
            }
        },
        components: {
            Address,
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/terminal/poland/app/modals/CompleteRegistrationModal.vue